import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';
import { normalize } from '../helpers/makeContexts';

const marketplaceInit = {
    isLoadingDatasetTemplates: false,
    selectedDatasetTemplateIds: [],
    dashboardTemplates: {},
    isLoadingDashboardTemplates: false,
    dashboardTemplatesFilters: {
        allDatasets: true,
        datasetIds: []
    },
    marketplaceLoaderCompleted: false,
    templateCubeDataInitialized: false,
};
/**
 * This section requires a rework to not include DashboardIntegrations and filter by categories. Not in the scope of this story but will comment out to prevent any errors
 * 
 */
function marketplaceReducer ( draft, { type, payload } ) {
    switch (type) {
        case 'setDashboardTemplates': {
            let newState = {}
            if (payload.Dashboards && payload.Dashboards.length) {
                for (let i = 0; i < payload.Dashboards.length; i++) {
                    let dash = payload.Dashboards[i]
                    newState[dash.id] = JSON.parse(JSON.stringify(dash))
                    
                    // let normCats = normalize(dash.Categories)
                    // let normIntegrations = normalize(dash.DashboardIntegrations)

                    // newState[dash.id].Categories = normCats
                    // newState[dash.id].DashboardIntegrations = normIntegrations
                }
            }
            draft.dashboardTemplates = newState
            break;
        }

        case "addDashboardTemplate": {
            draft.dashboardTemplates[payload.id] = JSON.parse(JSON.stringify(payload))
            // let normDTs = {}
            // let normCats = {}
            // if (payload.DashboardDataTables && payload.DashboardDataTables.length) {
            //     for (let i = 0; i < payload.DashboardDataTables.length; i++) {
            //         let dt = payload.DashboardDataTables[i]
            //         normDTs[dt.id] = dt
            //     }
            // }
            // if (payload.DashboardCategories && payload.DashboardCategories.length) {
            //     for (let i = 0; i < payload.DashboardCategories.length; i++) {
            //         let dashCat = payload.DashboardCategories[i]
            //         normCats[dashCat.id] = dashCat
            //     }
            // }
            // draft.dashboardTemplates[payload.id].DashboardDataTables = normDTs
            // draft.dashboardTemplates[payload.id].DashboardCategories = normCats
            break;
        }
        // ignore
        case 'setDashboardTemplatesFilterFields': {
            Object.keys(payload).forEach(k=>{
                draft.dashboardTemplatesFilters[k] = payload[k];
            })
            break;
        }
        case 'removePublishedTemplate': {
          delete draft.dashboardTemplates[payload.id]
          break;
        }
        case 'setIsLoadingDashboardTemplates': {
            draft.isLoadingDashboardTemplates = payload;
            break;
        }
        case 'setMarketplaceLoaderCompleted': {
            draft.marketplaceLoaderCompleted = payload;
            break;
        }
        case 'setTemplateCubeDataInitialized': {
            draft.templateCubeDataInitialized = payload;
            break;
        }
        default: {
            return null;
        }
    }
}

export const [MarketplaceContext,MarketplaceDispatchContext] = [createContext(null),createContext(null)];

export default function MarketplaceProvider ({ children }) {
    const [store, dispatch] = useImmerReducer(marketplaceReducer,marketplaceInit);

    return (
        <MarketplaceContext.Provider value={store}>
            <MarketplaceDispatchContext.Provider value={dispatch}>
                {children}
            </MarketplaceDispatchContext.Provider>
        </MarketplaceContext.Provider>
    )
}

export function useMarketplaceStore() {
    return useContext(MarketplaceContext);
}

export function useMarketplaceDispatch() {
    return useContext(MarketplaceDispatchContext);
}